import React from 'react';

const technology = {
    intro: {
        title: 'Technology',
        subTitle: 'Built by PhDs. Production-Ready.',
    },
    subIntro: {
        leftAligned: true,
        children: (
            <>
                <p>Two platforms. One philosophy: sovereign technology that solves real problems. No vendor lock-in. No black boxes. Full source access when you need it.</p>
            </>
        ),
    },
    divider: {},
    subIntro1: {
        children: (
            <>
                <h2>FENNEQ: AI & Optimization</h2>
                <p>Turn business problems into optimized solutions without writing optimization code.</p>
            </>
        ),
    },
    cardsGroup: {
        children: [
            {
                icon: 'icon-chart-line',
                title: 'Predict First',
                card: "ML models built from your historical data. Demand patterns, movement flows, failure probabilities — predictions feed directly into optimization.",
            },
            {
                icon: 'icon-code',
                title: 'Auto-Formulate',
                card: "Your problem mapped to the right math: QUBO, constraint satisfaction, linear programming. No PhD required on your side.",
            },
            {
                icon: 'icon-lightning',
                title: 'Intelligent Solving',
                card: "Quantum annealing, hybrid solvers, RL, classical optimizers. The platform picks what works best for your problem class.",
            },
        ],
    },
    divider1: {},
    subIntro2: {
        children: (
            <>
                <h2>QASER: Post-Quantum Cryptography</h2>
                <p>Four-product platform for complete quantum-safe migration. Sovereign implementations with no foreign dependencies.</p>
            </>
        ),
    },
    cardsGroup1: {
        children: [
            {
                icon: 'icon-search',
                title: 'QamiaScanner',
                card: "Instant cryptographic discovery. Find your exposure before attackers do.",
            },
            {
                icon: 'icon-shield-check',
                title: 'QamiaLayer',
                card: "4-week deployment. Quantum-safe tunneling with zero code changes.",
            },
            {
                icon: 'icon-code',
                title: 'QamiaIntegrate',
                card: "Permanent migration. Full ML-KEM and ML-DSA implementation with professional services.",
            },
            {
                icon: 'icon-layers',
                title: 'QamiaOrchestrator',
                card: "Ongoing management. Crypto-agility, compliance monitoring, certificate lifecycle.",
            },
        ],
    },
    divider2: {},
    subIntro3: {
        children: (
            <>
                <h2>Deployment</h2>
            </>
        ),
    },
    cardsGroup2: {
        children: [
            {
                icon: 'icon-cloud',
                title: 'Qamia Cloud',
                card: "Managed service. Regional data centers. We handle infrastructure.",
            },
            {
                icon: 'icon-server',
                title: 'Private / On-Prem',
                card: "Your infrastructure. Full control. Air-gapped options for highest security.",
            },
            {
                icon: 'icon-shield-check',
                title: 'Data Residency',
                card: "All data stays in region. Encrypted at rest and in transit. Full audit trails.",
            },
        ],
    },
    divider3: {},
    quote: {
        children: (
            <>
                Want the technical deep-dive? Let's talk architecture.
            </>
        ),
        cta: {
            url: '/contact',
            children: 'Contact Us',
        },
    },
};

export default technology;
